<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{ module }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{name:'dashboards'}">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">{{ module }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-lg-flex align-items-center justify-content-between mb-4">
              <div class="align-items-center d-lg-flex d-none">
                <div class="form-group mb-0 align-items-center d-flex">
                  <label class="mb-0">Show</label>
                  <select class="form-control ml-3" v-model="show" @change="getData">
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
                <div class="form-group mb-0 ml-3">
                  <select class="form-control" v-model="filterStatus" @change="getData">
                    <option value="">Semua Status</option>
                    <option value="0">Menunggu Konfirmasi Admin</option>
                    <option value="1">Menunggu Pembayaran</option>
                    <option value="2">Bukti Diupload</option>
                    <option value="3">Dikonfirmasi</option>
                    <option value="9">Dibatalkan</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-centered mb-0">
                <thead>
                  <tr>
                    <th>Kode</th>
                    <th>Customer</th>
                    <th>Total</th>
                    <th>Status</th>
                    <th>Tanggal</th>
                    <th>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="order in orders" :key="order.po_id">
                    <td>{{ order.po_code }}</td>
                    <td>{{ order.customer ? order.customer.usr_fullname : 'ID: ' + order.cst_id }}</td>
                    <td>Rp {{ formatNumber(order.po_total) }}</td>
                    <td>
                      <span :class="statusBadge(order.po_status)">{{ statusLabel(order.po_status) }}</span>
                    </td>
                    <td>{{ formatDate(order.created_at) }}</td>
                    <td>
                      <router-link class="btn btn-sm btn-info" :to="{name: 'product_orders_detail', params: {uuid: order.po_uuid}}">
                        Detail
                      </router-link>
                    </td>
                  </tr>
                  <tr v-if="orders.length === 0">
                    <td colspan="6" class="text-center">Tidak ada data</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="d-flex justify-content-end mt-3" v-if="nextPage">
              <button class="btn btn-secondary" @click="loadMore">Load More</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      module: 'Product Orders',
      table_module: 'product_orders',
      orders: [],
      show: 10,
      page: 1,
      filterStatus: '',
      nextPage: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.page = 1;
      this.axios.get(`/product-purchase/admin/orders?show=${this.show}&page=${this.page}&status=${this.filterStatus}`)
        .then(response => {
          if (response.data.status === 200) {
            this.orders = response.data.data.data;
            this.nextPage = response.data.data.next_page !== null;
          }
        });
    },
    loadMore() {
      this.page++;
      this.axios.get(`/product-purchase/admin/orders?show=${this.show}&page=${this.page}&status=${this.filterStatus}`)
        .then(response => {
          if (response.data.status === 200) {
            this.orders = [...this.orders, ...response.data.data.data];
            this.nextPage = response.data.data.next_page !== null;
          }
        });
    },
    statusLabel(status) {
      const labels = { 0: 'Menunggu Konfirmasi Admin', 1: 'Menunggu Pembayaran', 2: 'Bukti Diupload', 3: 'Dikonfirmasi', 9: 'Dibatalkan' };
      return labels[status] || 'Unknown';
    },
    statusBadge(status) {
      const classes = { 0: 'badge badge-warning', 1: 'badge badge-primary', 2: 'badge badge-info', 3: 'badge badge-success', 9: 'badge badge-danger' };
      return classes[status] || 'badge badge-secondary';
    },
    formatNumber(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const opts = { timeZone: 'Asia/Jakarta', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false };
      return d.toLocaleString('id-ID', opts).replace(/(\d+)\/(\d+)\/(\d+)/, '$1-$2-$3').replace(/\./g, ':');
    },
  }
};
</script>
